import { isApiError, isFetchBaseQueryError, type SveaError } from "../types/error";

export const normalizeError = (err: unknown): SveaError => {
	try {
		if (isApiError(err)) {
			return {
				errorMsg: err.data.description || "",
				statusCode: err.status,
				errorCode: err.data.errorCode,
			};
		}

		if (isFetchBaseQueryError(err)) {
			const message = "error" in err ? err.error : JSON.stringify(err.data);
			const statusCode = typeof err.status === "number" ? err.status : null;
			const errorCode = typeof err.status !== "number" ? err.status : null;
			return { errorMsg: message, statusCode, errorCode };
		}

		if (err instanceof Error) {
			return {
				errorMsg: err.message,
				statusCode: null,
				stack: err.stack,
			};
		}

		return {
			errorMsg: typeof err === "string" ? err : JSON.stringify(err),
			statusCode: null,
		};
	} catch {
		return {
			errorMsg: "Unhandled error",
			statusCode: null,
			errorCode: null,
		};
	}
};
